import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-terms',
    standalone: true,
    imports: [CommonModule],
    template: `
    <div class="min-h-screen bg-gray-50 py-12 px-6 lg:px-24">
      <div class="max-w-4xl mx-auto bg-white rounded-3xl shadow-sm border border-gray-100 p-8 md:p-12">
        <h1 class="text-4xl font-extrabold text-gray-900 mb-8 border-b border-gray-100 pb-6">Terms of Service</h1>
        
        <div class="space-y-8 text-gray-700 leading-relaxed">
          <section>
            <h2 class="text-2xl font-bold text-gray-800 mb-4">1. Agreement to Terms</h2>
            <p>By accessing or using our services, you agree to be bound by these Terms of Service. If you disagree with any part of the terms, then you may not access the service.</p>
          </section>

          <section>
            <h2 class="text-2xl font-bold text-gray-800 mb-4">2. Intellectual Property</h2>
            <p>The Service and its original content, features, and functionality are and will remain the exclusive property of reGenesis and its licensors.</p>
          </section>

          <section>
            <h2 class="text-2xl font-bold text-gray-800 mb-4">3. User Obligations</h2>
            <p>You agree not to use the Service for any unlawful purpose or any purpose prohibited under this clause. You agree not to use the Service in any way that could damage the Service or general business of reGenesis.</p>
          </section>

          <section>
            <h2 class="text-2xl font-bold text-gray-800 mb-4">4. Limitation of Liability</h2>
            <p>In no event shall reGenesis be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses.</p>
          </section>

          <section class="mt-12 pt-8 border-t border-gray-100 text-sm text-gray-500">
            <p>Last updated: December 2025</p>
          </section>
        </div>
      </div>
    </div>
  `
})
export class TermsPageComponent { }
